if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined, showAssociatedOnly) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          if (!Alpine.store('xClawStickyLbPrices')) {
            Alpine.store('xClawStickyLbPrices', {
              enabled: false,
              showCompetitor: true,
              lbPrice: '',
              competitorsPrice: '',
            });
          }
          if (!Alpine.store('xClawStickyControls')) {
            Alpine.store('xClawStickyControls', {
              ready: false,
              clawSizes: [],
              dinnerSizes: [],
              selectedClawIndex: 0,
              selectedDinnerIndex: 0,
              selectedClawLabel: '',
              selectedDinnerLabel: '',
              _api: null,
              _updateSummary() {
                const size = this.clawSizes[this.selectedClawIndex];
                this.selectedClawLabel = size?.label || size?.name || '';
                const dinner = this.dinnerSizes[this.selectedDinnerIndex];
                if (dinner === undefined || dinner === null || dinner === '') {
                  this.selectedDinnerLabel = '';
                  return;
                }
                const raw = String(dinner).trim();
                this.selectedDinnerLabel = /^dinner\s+for\s+/i.test(raw)
                  ? raw.replace(/^d/, 'D')
                  : `Dinner for ${raw}`;
              },
              bind(api) {
                this._api = api;
                this.ready = true;
                this.syncFrom(api);
              },
              syncFrom(api) {
                if (!api) return;
                const shortClawLabel = (name) => {
                  const title = String(name || '').toLowerCase();
                  if (title.includes('mega')) return 'Mega';
                  if (title.includes('colossal')) return 'Colossal';
                  if (title.includes('jumbo')) return 'Jumbo';
                  if (title.includes('large')) return 'Large';
                  if (title.includes('medium')) return 'Medium';
                  return String(name || '');
                };
                this.clawSizes = (api.clawSizes || []).map((size) => ({
                  name: size.name,
                  label: shortClawLabel(size.name),
                }));
                this.dinnerSizes = (api.dinnerSizes || []).map((dinner) => String(dinner));
                this.selectedClawIndex = Number.isInteger(api.selectedClawIndex) ? api.selectedClawIndex : 0;
                this.selectedDinnerIndex = Number.isInteger(api.selectedDinnerIndex) ? api.selectedDinnerIndex : 0;
                this._updateSummary();
              },
              selectClaw(index) {
                const nextIndex = parseInt(index, 10);
                if (Number.isNaN(nextIndex) || !this._api) return;
                this.selectedClawIndex = nextIndex;
                this._updateSummary();
                this._api.selectClawIndex(nextIndex);
              },
              selectDinner(index) {
                const nextIndex = parseInt(index, 10);
                if (Number.isNaN(nextIndex) || !this._api) return;
                this.selectedDinnerIndex = nextIndex;
                this._updateSummary();
                this._api.selectDinnerIndex(nextIndex);
              },
            });
          }
          if (showAssociatedOnly) {
            document.addEventListener(`eurus:media-gallery-ready:${sectionId}`, () => {
              this.renderMedia();
            }, { once: true });
          }
          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            this.renderVariant(e.detail.html);
            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });
        },
        formatLbPrice(val) {
          if (val === null || val === undefined || val === '') return '';
          const s = String(val).trim();
          return s.startsWith('$') ? s : `$${s}`;
        },
        renderProductPrice(html) {
          const destinations = Array.from(document.getElementsByClassName(`price-sticky-${sectionId}`));
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          if (showAssociatedOnly) {
            this.$nextTick(() => {
              const destination = document.getElementById('product-image-sticky-' + sectionId)?.querySelector('img');
              const source = document.querySelector('.product-media-container')?.querySelector('.media_active img')?.getAttribute('src');

              if (source && destination) destination.setAttribute('src', source);
            })
          } else {
            const destination = document.getElementById('product-image-sticky-' + sectionId);
            const source = html.getElementById('product-image-sticky-' + sectionId);
    
            if (source && destination) destination.innerHTML = source.innerHTML;
          }
        },
        renderVariant(html) {
          // Claw sticky selects are Alpine-bound to xClawStickyControls; do not replace them
          // with generic variant markup from section HTML (that disconnects combined listings).
          if (Alpine.store('xClawStickyControls')?.ready) return;

          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          if (Alpine.store('xClawStickyControls')?.ready) return;

          Array.from(event.target.options).forEach((option) => {
            option.removeAttribute('selected');
            if (option.selected) option.setAttribute('selected', '');
          });
          const input = event.target.selectedOptions[0];
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}